<template>
  <div>
    <b-modal
      v-model="modalShow"
      size="lg"
      centered
      hide-footer
      header-class="header-modal-class"
      content-class="content-modal-class"
    >
      <template #modal-header>
        <span class="title-modal">ตั้งค่ารหัสผ่านใหม่</span>
        <a class="pointer" @click="hide()">
          <font-awesome-icon icon="times" />
        </a>
      </template>

      <b-row class="no-gutters">
        <b-col>
          <div class="">
            <InputText
              textFloat="รหัสผ่านใหม่"
              placeholder="รหัสผ่านใหม่"
              type="password"
              name="password"
              v-model="form.password"
              isRequired
              detail="(รหัสผ่านจำเป็นจะต้องมีตัวเลขรวมกันอย่างน้อย 6 ตัว เพื่อความปลอดภัย)"
              :isValidate="$v.form.password.$error"
              :v="$v.form.password"
            />
          </div>
        </b-col>
      </b-row>
      <b-row class="no-gutters">
        <b-col>
          <div class="">
            <InputText
              textFloat="ยืนยันรหัสผ่านใหม่"
              placeholder="ยืนยันรหัสผ่านใหม่"
              type="password"
              name="confirmPassword"
              v-model="form.confirmPassword"
              isRequired
              :isValidate="$v.form.confirmPassword.$error"
              :v="$v.form.confirmPassword"
            />
          </div>
        </b-col>
      </b-row>

      <b-row class="no-gutters">
        <b-col>
          <div class="text-danger text-description">
        <span>การเปลี่ยนรหัสผ่านจะนำบัญชีนี้ออกจากระบบ</span>
          </div>
        </b-col>
      </b-row>

      <div class="mt-3 d-flex justify-content-between">
        <div>
          <b-button class="btn-main-2" @click="hide()">
            ยกเลิก
          </b-button>
        </div>
        <b-button class="btn-main" @click="submit()">ยืนยัน</b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import InputText from "@/components/inputs/InputText";
import { required, minLength, sameAs, helpers } from "vuelidate/lib/validators";
const alpha = helpers.regex("alpha", /[ก-๙a-zA-Z]*$/);
const passwordNumber = helpers.regex("alpha", /[0-9]+/);
import ModalAlertConfirm from "@/components/modal/alert/ModalAlertConfirm";

export default {
  components: {
    InputText,
    ModalAlertConfirm,
  },
  data() {
    return {
      modalShow: false,
      form: {
        password: "",
        confirmPassword: "",
      },
    };
  },
  methods: {
    show() {
      this.modalShow = true;
    },
    hide() {
      (this.form.password = ""), (this.form.confirmPassword = "");
      this.modalShow = false;
    },
    submit() {
      this.$v.form.$touch();
      if (this.$v.form.$error) return;
      this.$emit("resetPassword", this.form);
      this.form.password = "";
      this.form.confirmPassword = "";
      this.hide();
      this.$v.$reset();
    },
  },
  validations() {
    return {
      form: {
        password: { required, minLength: minLength(6), passwordNumber, alpha },
        confirmPassword: {
          required,
          sameAsPassword: sameAs("password"),
          passwordNumber,
          alpha,
        },
      },
    };
  },
};
</script>

<style lang="scss" scoped>
/deep/ .content-modal-class {
  border: 0;
}
.title-modal {
  font-weight: bold;
}
/deep/ .header-modal-class {
  border-bottom: 0px;
  padding-bottom: 0px;
}
.text-description {
  font-size: 14px !important;
  margin-bottom: 0px;
}
</style>
